import React, { useState } from "react"

import { useHistory } from "react-router-dom"
import { gql, useQuery } from "urql"

import WithLoadingIndicator from "~tailwindui/Basics/WithLoadingIndicator"
import Table from "~tailwindui/Table/Table"

import LocalTime from "components/LocalTime"
import Header from "components/OrganizationAdmin/components/DisplayableFormikForm/Header"

const SurveysPage = () => {
  const history = useHistory()

  const [page, setPage] = useState(1)
  const [result] = useQuery({ query: surveysQuery, variables: { page } })
  return (
    <>
      <Header title="Surveys" />
      <WithLoadingIndicator result={result}>
        {({ data }) => (
          <Table
            data={data.viewer.organization.surveys}
            changePage={setPage}
            rowCallback={survey => history.push(`/surveys/${survey.id}`)}
            cols={[
              { header: "Name", value: survey => survey.name },
              {
                header: "Start Date",
                value: survey => (
                  <LocalTime
                    key="startsOn"
                    timestamp={survey.startsOn}
                    omitTime
                  />
                ),
              },
              {
                header: "Total Responses",
                value: survey => survey.totalResponses,
              },
            ]}
          />
        )}
      </WithLoadingIndicator>
    </>
  )
}

const surveysQuery = gql`
  query Surveys($page: Int!) {
    viewer {
      organization {
        surveys(page: $page) {
          currentPage
          totalPages
          data {
            id
            name
            startsOn
            totalResponses
          }
        }
      }
    }
  }
`

export default SurveysPage
